import { useMutation } from "@tanstack/react-query";

import { joinProgram } from "../services/goHireService";
import { JoinProgramResponse } from "../types/program.types";

export const useJoinProgram = (
  serviceId: number,
  options?: { onSuccess?: (data: JoinProgramResponse["data"]) => void }
) => {
  return useMutation<JoinProgramResponse["data"], Error>({
    mutationFn: () => joinProgram(serviceId),
    onSuccess: (data) => {
      options?.onSuccess?.(data);
    },
  });
};
